import React, { useState } from 'react'
import { Button, Dropdown, Form, Input, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useStore } from "../contexts/FireStoreContext"

const FireStoreSearch = ({
  table,
  searchOptions,
  setResult,
  stickyCondition = []
}) => {
  const { searchDocuments } = useStore()
  const [searchBy, setSearchBy] = useState(searchOptions[0].key)

  const handleSearch = (s) => {
    const el = document.querySelector('#search')
    el.value = ''
    el.focus()
    setSearchBy(s)
    setResult([], 0)
  }

  const search = async (e) => {
    const searchValue = String(e.target.value)
    if (searchValue.length > 1) {
      // console.log('searchValue', searchValue)
      // console.log('searchBy', searchBy)
      searchDocuments(table, searchBy, searchValue, stickyCondition)
        .then(results => {
          // console.log("results", results)
          setResult(results, searchValue.length)
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      setResult([], searchValue.length)
    }
  }

  const menu = (
    <Menu>
      {searchOptions.map(s => (
        <Menu.Item key={s.key}>
          <Button type="text" onClick={e => handleSearch(s.key)}>{s.label}</Button>
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Input.Group>
      <Form.Item
        name="search"
        noStyle
      >
        <Input style={{ width: '40%' }} placeholder="Filter..." onChange={search} className="border-primary" />
      </Form.Item>
      <Form.Item
        name="searchBy"
        noStyle
      >
        <Dropdown overlay={menu} trigger={['click']}>
          <Button type="primary" onClick={e => e.preventDefault()}>
            By {searchOptions.find(s => searchBy === s.key)['label']} <DownOutlined />
          </Button>
        </Dropdown>
      </Form.Item>
    </Input.Group>
  )
}

export default FireStoreSearch
